import { render, staticRenderFns } from "./ProductSelectionModal.vue?vue&type=template&id=2a45b536&scoped=true"
import script from "./ProductSelectionModal.vue?vue&type=script&lang=js"
export * from "./ProductSelectionModal.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectionModal.vue?vue&type=style&index=0&id=2a45b536&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45b536",
  null
  
)

export default component.exports